"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EpcHoeWerktHet() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: illustrationRef,
    isVisible: illustrationVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section className="py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div ref={textRef} className="transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" style={{
          opacity: textVisible ? 1 : 0,
          transform: textVisible ? "translateX(0)" : "translateX(-20px)"
        }}>
            <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-6">
              EPC - Hoe werkt het?
            </h2>
            <p className="text-base lg:text-lg text-foreground/80 leading-relaxed">
              Een energieprestatiecertificaat (EPC) is een wettelijk verplicht
              document dat de energieprestaties van een woning of gebouw
              beoordeelt. Het geeft een duidelijk overzicht van het
              energieverbruik en biedt aanbevelingen voor verbetering. Ons team
              van gecertificeerde experts voert een grondige inspectie uit en
              levert binnen enkele dagen een officieel EPC-attest af.
            </p>
          </div>

          {}
          <div ref={illustrationRef} className="flex items-center justify-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:scale-[1.02]" style={{
          opacity: illustrationVisible ? 1 : 0,
          transform: illustrationVisible ? "translateX(0)" : "translateX(10px)"
        }}>
            <div className="relative w-full max-w-md aspect-square">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1511866/img/epc_energy_meter_illustration.png" alt="EPC energiemeter illustratie" className="w-full h-full object-contain" />
            </div>
          </div>
        </div>

        {}
        <div className="mt-12 lg:mt-16 h-px bg-transparent" />
      </div>
    </section>;
}